// Fetch the week plans needed to source the report's "notices" (per-day
// comments). There is no range/bulk endpoint, so we fetch one (year, week) at a
// time and concatenate. `viewerMode: false` gives the report's scoping for free:
// an admin gets every employee for the week, a regular user gets only their own.
// An empty week returns 404 — swallow it (and any transient error) as "no plan
// that week" so one gap can't fail the whole report.

import { WeekPlanService } from '../../services/weekPlanService';

/**
 * @param {Array<{year:number, week:number}>} weeks
 * @returns {Promise<object[]>} flat array of WeekPlanEmployeeDTO across all weeks
 */
export const fetchWeekPlans = async (weeks = []) => {
  const perWeek = await Promise.all(
    weeks.map(({ year, week }) =>
      WeekPlanService.getUserWeekPlan(week, year, false).catch(() => [])
    )
  );
  return perWeek.flat();
};
